// Thin wrappers over sessionStorage keyed by `pdfTabOpened:<documentKey>`.
// The flag survives full-page reloads (unlike the in-memory registry), so the
// reminder can still fire even when the window handle is lost.

const KEY_PREFIX = 'pdfTabOpened:'

function storageKey(documentKey: string): string {
  return KEY_PREFIX + documentKey
}

export function setOpened(documentKey: string): void {
  try {
    sessionStorage.setItem(storageKey(documentKey), '1')
  } catch {
    // sessionStorage unavailable (SSR, privacy mode) — silently ignore.
  }
}

export function isOpened(documentKey: string): boolean {
  try {
    return sessionStorage.getItem(storageKey(documentKey)) === '1'
  } catch {
    return false
  }
}

export function clear(documentKey: string): void {
  try {
    sessionStorage.removeItem(storageKey(documentKey))
  } catch {
    // Silently ignore.
  }
}
